module.exports = __webpack_public_path__ + "static/media/dg2.84e67f00.jpg";